import React, { useEffect } from 'react';
import { object } from 'prop-types';

import useOrderMtDetail from '../hooks/useOrderMtDetail';
import LoadingDetail from '../../components/LoadingDetail';
import useEventTracker from '../../tracker';

import { styDetail } from './style';

/**
 * @param {object}  DetailProps
 * @param {import('@services/api/stock/order/margin').OrderMt}  DetailProps.item
 */
function Detail({ item }) {
  const { order_no: orderNo } = item;

  const { eventExpandOrderDetail } = useEventTracker();

  useEffect(() => {
    eventExpandOrderDetail({
      accountType: 'Margin',
      orderType: 'Limit Order',
      lot: item.lot_input,
      period: item.period,
      price: item.price_order,
      total: item.total_price,
    });
  }, []);

  const { data, isLoading } = useOrderMtDetail(orderNo);

  if (isLoading) {
    return <LoadingDetail />;
  }

  const detail = { ...item, ...(data?.result?.results[0] || {}) };

  const idxOrder = detail.idx_order_no !== '0' ? detail.idx_order_no || '-' : '-';
  const formattedPeriod =
    (detail.period === 'day' && 'Hari') || (detail.period === 'session' && 'Sesi') || '-';

  // Status is Rejected
  const isShowAlasan = detail.status !== '8';

  return (
    <section className={styDetail}>
      <div>
        <div>
          <span>IDX order</span>
          <span>{idxOrder}</span>
        </div>
        <div>
          <span>Periode</span>
          <span>{formattedPeriod}</span>
        </div>
      </div>
      <div>
        <div>
          <span>Waktu</span>
          <span>{detail.executed_time}</span>
        </div>
        <div>
          <span>Lot Order</span>
          <span>{detail.open_order}</span>
        </div>
      </div>
      <div>
        <div>
          <span>Lot Done</span>
          <span>{detail.done_order}</span>
        </div>
        <div>
          <span>Volume</span>
          <span>{detail.lot_input || '0'}</span>
        </div>
      </div>
      {!isShowAlasan && (
        <div>
          <div>
            <span>Alasan</span>
            <span style={{ whiteSpace: 'break-spaces' }}>{detail.message}</span>
          </div>
        </div>
      )}
    </section>
  );
}

Detail.propTypes = {
  item: object.isRequired,
};

export default Detail;
